module.exports = __webpack_public_path__ + "img/1.dbdbad48.png";